export default import.meta.ROLLUP_FILE_URL_DccSx1yc;